import { apiClient, ApiError } from '@/services/api-client'
import { filenameFromContentDisposition } from '@/utils/file-download'
import type {
  ExportJobListResponse,
  RequestExportBody,
  RequestExportResponse,
} from '@/features/file-exports/types/export-job.types'

function getApiBase(): string {
  return (window.__NAVEGA_CONFIG__?.apiUrl ?? import.meta.env.VITE_API_URL ?? '') + '/api/v1'
}

export const exportsService = {
  list: (page: number, token: string) =>
    apiClient.get<ExportJobListResponse>(`/exports?page=${page}&pageSize=20`, { token }),

  requestExport: (body: RequestExportBody, token: string) =>
    apiClient.post<RequestExportResponse>('/exports', body, { token }),

  downloadFile: async (jobId: string, token: string): Promise<{ blob: Blob; filename: string }> => {
    const response = await fetch(`${getApiBase()}/exports/${jobId}/download`, {
      headers: { Authorization: `Bearer ${token}` },
    })

    if (!response.ok) {
      const json = await response.json().catch(() => ({}))
      const err = json?.error ?? {}
      throw new ApiError(
        response.status,
        err.code ?? 'UNKNOWN_ERROR',
        err.message ?? 'Erro inesperado',
      )
    }

    const filename = filenameFromContentDisposition(response, `export-${jobId}`)

    const blob = await response.blob()
    return { blob, filename }
  },

  getSseUrl: (token: string): string =>
    `${getApiBase()}/exports/events?token=${encodeURIComponent(token)}`,
}
